// extracted by mini-css-extract-plugin
export default {"settingPageTabs":"settings_settingPageTabs__GYJNz","pad_60":"settings_pad_60__qlnYx"};